module.exports = __webpack_public_path__ + "media/images/homes/android_pos2x-5b42022503fb2d73e165f0779d833c00.png";